/* eslint-disable */
class decimalService {

    formatNumberTo2Decimal (number) {
        if (number != null && number != '') {
            number = parseFloat(number);
            const options = {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            };
            return Number(number).toLocaleString('en', options);
        }
        return number;
    }

}
  
export default new decimalService();